








import Header from '@/views/templates/Header.vue'
import Footer from '@/views/templates/Footer.vue'
export default
  name: 'Main'

  components: {
    Header
    Footer
  }

  data: () ->
    setcolor: false

  methods: {
    setColor: (state) ->
      @setcolor = state
  }
